/**
 * Loading / error / data envelope every dashboard page's screen facade emits. String values, not ordinals —
 * components hold this as a template constant.
 */
export enum DashboardVmState {
  LOADING = 'loading',
  ERROR = 'error',
  DATA = 'data',
}

export interface DashboardVm<T> {
  state: DashboardVmState;
  /** Server time clamped to the client clock; null while loading or on error. */
  asOfUtc: Date | null;
  data: T | null;
  /** The server's validation text when a 400 carried one; null otherwise. */
  errorMessage: string | null;
}
